import React, { useContext, useEffect, useRef } from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import { RefsContext } from '@bbkFunnelUtils/refs.context';

type Props = {
  class: string;
  title: React.ReactNode;
  hero: React.ReactNode;
  actions: React.ReactNode;
};

const SeventyThirtyRow: React.FC<Props> = (props) => {
  const { class: classes, hero, title, actions } = props;

  const refsPrefix = '123'; // FIXME
  const refsContext = useContext(RefsContext);
  const titleRef = useRef<HTMLSpanElement>(null);
  useEffect(() => refsContext?.addRef(`${refsPrefix}`, titleRef), [titleRef]);

  return (
    <div className="seventy-thirty-row">
      <div className={cs('STRContainer', classes)}>
        <div className="modal-top">{hero}</div>
        <div className="modal-bottom">
          <div className="STR-content-container">
            <div className="left">
              <span ref={titleRef}>{title}</span>
            </div>
            <div className="right">{actions}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

SeventyThirtyRow.closeBtnFill = '#fff';

export default SeventyThirtyRow;
